import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const getManufactureOrderRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/manufacture-orders/:id',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/manufacture-orders/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getManufactureOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 33,
        "number": "1024",
        "revisionNumber": 2,
        "note": "",
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "dateCreated": "2021-05-14T15:49:17.777-0600",
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2021-05-14T15:49:18.744-0600"
        },
        "dateIssued": "2021-05-14T15:49:18.723-0600",
        "dateScheduled": "2021-05-14T15:49:08.160-0600",
        "url": "",
        "percentComplete": "0%",
        "status": "Issued",
        "class": {
            "id": 1,
            "name": "None"
        },
        "configurations": [
            {
                "id": 384,
                "bom": {
                    "id": 7,
                    "name": "BK100"
                },
                "stage": false,
                "priceAdjustment": "0",
                "unitCost": "0",
                "dateScheduled": "2021-05-14T15:49:00.000-0600",
                "dateScheduledToStart": "2021-05-14T15:49:00.000-0600",
                "note": "",
                "sortId": 1,
                "stageLevel": 1,
                "hasSo": false,
                "status": "Entered",
                "quantity": "1",
                "quantityFulfilled": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "priority": "3-Normal",
                "items": [
                    {
                        "id": 385,
                        "bom": {
                            "id": 7,
                            "name": "BK100"
                        },
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 1,
                        "stageLevel": 1,
                        "hasSo": false,
                        "part": {
                            "id": 80,
                            "name": "BK100",
                            "description": "New to Biking Kit"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "1",
                        "quantityFulfilled": "0",
                        "class": {
                            "id": 1,
                            "name": "None"
                        },
                        "priority": "All",
                        "type": "Finished Good"
                    },
                    {
                        "id": 386,
                        "bom": {
                            "id": 7,
                            "name": "BK100"
                        },
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 2,
                        "stageLevel": 1,
                        "hasSo": false,
                        "part": {
                            "id": 52,
                            "name": "PM100",
                            "description": "Entry Bike Pump"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "1",
                        "quantityFulfilled": "0",
                        "class": {
                            "id": 1,
                            "name": "None"
                        },
                        "priority": "All",
                        "type": "Raw Good"
                    },
                    {
                        "id": 387,
                        "bom": {
                            "id": 7,
                            "name": "BK100"
                        },
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 3,
                        "stageLevel": 1,
                        "hasSo": false,
                        "part": {
                            "id": 77,
                            "name": "H100",
                            "description": "Basic Bike Helmet"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "1",
                        "quantityFulfilled": "0",
                        "class": {
                            "id": 1,
                            "name": "None"
                        },
                        "priority": "All",
                        "type": "Raw Good"
                    },
                    {
                        "id": 388,
                        "bom": {
                            "id": 7,
                            "name": "BK100"
                        },
                        "stage": false,
                        "priceAdjustment": "0",
                        "unitCost": "0",
                        "sortId": 4,
                        "stageLevel": 1,
                        "hasSo": false,
                        "part": {
                            "id": 56,
                            "name": "PK100",
                            "description": "Patch Kit"
                        },
                        "uom": {
                            "id": 1,
                            "name": "Each",
                            "abbreviation": "ea"
                        },
                        "oneTimeItem": false,
                        "status": "Entered",
                        "quantity": "1",
                        "quantityFulfilled": "0",
                        "class": {
                            "id": 1,
                            "name": "None"
                        },
                        "priority": "All",
                        "type": "Raw Good"
                    }
                ]
            }
        ],
        "customFields": [
            {
                "id": 25,
                "name": "Custom",
                "value": "",
                "type": "Text"
            },
            {
                "id": 29,
                "name": "Type",
                "value": "",
                "type": "Drop-Down List"
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'get-manufacture-order',
    title: 'Get a manufacture order',
    description: 'Retrieves the details of an existing manufacture order. You only need to provide the unique manufacture order ID.',
    endpoint: {
        verb: 'GET',
        path: '/manufacture-orders/:id',
        tooltip: 'Get a manufacture order',
    },
    attributes: [],
    requestObject: getManufactureOrderRequest,
    responseObject: getManufactureOrdersResponse,
};

export default data;
